import type { PermitDetail } from './types';

interface Props {
  permit: PermitDetail;
}

export function ApprovalHistoryTab({ permit }: Props) {
  const cycle1 = permit.approvalRecords.find((r) => r.cycleNumber === 1);

  if (!cycle1) {
    return (
      <div className="bg-card rounded-2xl border border-border shadow-sm p-12 text-center text-sm text-muted-foreground">
        No approval records.
      </div>
    );
  }

  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">Approval History</h3>
        <p className="text-xs text-muted-foreground mt-0.5">Cycle 1</p>
      </div>
      <div>
        <div className="flex items-start justify-between gap-4 px-6 py-4">
          <div className="flex items-start gap-4">
            <div
              className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                cycle1.decision === 'APPROVED'
                  ? 'bg-success/10 text-success'
                  : 'bg-red-100 text-red-600'
              }`}
            >
              1
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm font-semibold text-foreground">Cycle 1</span>
                <span
                  className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                    cycle1.decision === 'APPROVED'
                      ? 'bg-success/10 text-success'
                      : 'bg-red-100 text-red-600'
                  }`}
                >
                  {cycle1.decision}
                </span>
              </div>
              <p className="mt-1 text-xs text-muted-foreground font-medium">
                {cycle1.decision === 'APPROVED' ? 'Approved by' : 'Reviewed by'}:{' '}
                {cycle1.reviewedBy.name}
              </p>
              {cycle1.comments && (
                <p className="mt-1 text-sm text-muted-foreground">{cycle1.comments}</p>
              )}
            </div>
          </div>
          <span className="shrink-0 text-xs text-muted-foreground whitespace-nowrap">
            {new Date(cycle1.reviewedAt).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
}
